var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSms = function SvgSms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.291 18.824 0 20l1.176-5.291A9.956 9.956 0 0 1 0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10a9.955 9.955 0 0 1-4.709-1.176Zm.29-2.113.653.35A7.956 7.956 0 0 0 10 18a8 8 0 1 0-8-8c0 1.334.325 2.618.94 3.766l.349.653-.655 2.947 2.947-.655Z",
    fill: "#1D1737"
  })));
};
export default SvgSms;